import React, { useRef } from 'react';
import AceEditor from 'react-ace';
import 'ace-builds/src-min-noconflict/theme-monokai';
import 'ace-builds/src-min-noconflict/theme-tomorrow';
import 'ace-builds/src-min-noconflict/ext-language_tools';
import 'ace-builds/src-min-noconflict/ext-searchbox';
import 'ace-builds/src-min-noconflict/mode-python';
import 'ace-builds/src-min-noconflict/snippets/python.js';
import 'ace-builds/src-min-noconflict/snippets/text.js';
import { SimpleLanguageDropdown } from 'components/FreecodePage/FreecodeTabs/FreecodeButtons';

import { Languages } from 'constants/languages';
import { useAppContext, useFreecodeContextData, useFreecodeContextRun } from 'hooks/useContext';
import { EditorContainer, HeaderContainer, CreatorTabContentBackground } from './styles';
import { Label } from '../styles';

export default function FreecodeSkeletonEditor() {
  const { testImpl, setTestImpl } = useFreecodeContextData();
  const { isDarkMode } = useAppContext();
  const { language } = useFreecodeContextRun();

  const editorRef = useRef(null);

  const onBlur = () => {
    if (!editorRef.current) return;
    let cursorPosition = editorRef.current.getCursorPosition();
    editorRef.current.navigateTo(editorRef.current.getFirstVisibleRow(), 0);
    window.fsEditorPosSkel = {
      row: cursorPosition.row,
      column: cursorPosition.column,
      scrollRow: editorRef.current.getCursorPositionScreen().row,
    };
  };

  const onEditorLoad = (editor) => {
    editorRef.current = editor;
    if (window.fsEditorPosSkel) {
      editorRef.current.scrollToLine(window.fsEditorPosSkel.scrollRow);
      editorRef.current.navigateTo(window.fsEditorPosSkel.row, window.fsEditorPosSkel.column);
      editorRef.current.focus();
      window.fsEditorPosSkel = undefined;
    }
  };

  const onChange = (value) => {
    let generated = testImpl.generated;
    generated.skeletons[language] = value;
    setTestImpl((oldTestImpl) => ({ ...oldTestImpl, generated }));
  };

  return (
    <CreatorTabContentBackground>
      <HeaderContainer>
        <Label>Here you can manually edit the code presented to the candidate:</Label>
        <SimpleLanguageDropdown />
      </HeaderContainer>
      <EditorContainer>
        <AceEditor
          placeholder="Please reset the code..."
          mode={Languages[language].EditorName}
          theme={isDarkMode ? 'monokai' : 'tomorrow'}
          fontSize={15}
          onLoad={onEditorLoad}
          onChange={onChange}
          onBlur={onBlur}
          value={testImpl?.generated?.skeletons?.[language] ?? 'No skeleton exists. Please regenerate the code.'}
          name="solutionEditorId"
          showPrintMargin={false}
          wrapEnabled={true}
          width={'100%'}
          height={'100%'}
          editorProps={{ $blockScrolling: true }}
          enableBasicAutocompletion={true}
          enableLiveAutocompletion={true}
          enableSnippets={true}
          tabSize={4}
        />
      </EditorContainer>
    </CreatorTabContentBackground>
  );
}
